export class FeatureStatus {
	current: number;
	constructor(
		public available: boolean,
		public status: boolean,
		public permission: boolean = true,
		public isLoading: boolean = true) { }
}
